export class centricOrderHistory {

    poNumber?: string;

    constructor(
        poNumber?: string
    ) {

        this.poNumber = poNumber;
       
    }
}
